module.exports = __webpack_public_path__ + "instruction.pdf";